import React from 'react'
import styles from './styles.module.scss'
import { Button, Divider } from 'antd'
import { ArticleListMethod, MeshList } from 'sdss/types/ListArticlesModules'

export interface MeshColors {
  [index: string]: string;
}

export function ArticleCard(props: ArticleListMethod) {
  const { title, author_list, journal_title_abbr, pmid, mesh_list, abstract_list, published_date, volume, issue, pagination, doi } = props

  // 查看原文 => 跳转到 pubmed 官网 + /pmid/
  const checkText = () => {
    window.open(`https://pubmed.ncbi.nlm.nih.gov/${pmid}/`)
  }

  return (
    <div className={styles.article} key={title + pmid}>
      <div className={styles.header}>
        <div className={styles.headerText} dangerouslySetInnerHTML={{ __html: title }}></div>
        <Button style={{ borderRadius: 4 }} onClick={checkText}>查看原文</Button>
      </div>
      <div className={styles.articlePart}>
        <span>作者: </span>
        {
          author_list.map((item: string, index: number) => {
            let name = ''
            if (index !== author_list.length - 1) {
              name += ` ${item} ,`
            } else {
              name += ` ${item}`
            }
            return name
          })
        }
      </div>
      <div className={styles.articlePart}>
        <span>期刊: </span>
        {
          props.doi ? <span>{journal_title_abbr}. {published_date};{volume}({issue}):{pagination}. doi:{doi}</span> : <span>{journal_title_abbr}. {published_date};{volume}({issue}):{pagination}.</span>
        }
      </div>
      <div className={styles.articlePart}>
        <span>PMID: </span>
        <span>{pmid}</span>
      </div>
      <div className={styles.articlePart}>
        <span>MeSH词: </span>
        <span>{mesh_list.map((mesh: MeshList) => randomColorTag(mesh))}</span>
      </div>
      {abstract_list.length > 0 ? <div className={styles.articlePart}>
        <span>摘要:</span>
        <div style={{ marginTop: 10 }}>
          <div>
            {abstract_list.map((abstractLists: any, index: number) => {
              let abstract = []
              for (let item in abstractLists) {
                abstract.push(!abstractLists.null ? <div key={index} dangerouslySetInnerHTML={{ __html: abstractLists[item] }}>
                </div> : <div key={index} dangerouslySetInnerHTML={{ __html: abstractLists.null }}></div>)
              }
              return abstract
            })}
          </div>
        </div>
      </div> : null
      }
      <Divider />
    </div>
  )
}

function randomColorTag(val: MeshList) {
  const colors: MeshColors = { A: 'rgba(91,127,249)', B: 'rgb(246,198,27)', C: 'rgb(72,192,122)', D: 'rgb(244,92,106)', E: 'rgb(241,149,29)', F: 'rgb(59,183,237)', G: 'rgb(102,98,255)', N: 'rgb(255,79,156)', other: 'rgb(91,156,249)' }
  const bgColors: MeshColors = { A: 'rgba(91,127,249,0.1)', B: 'rgba(246,198,27,0.1)', C: 'rgba(72,192,122,0.1)', D: 'rgba(244,92,106,0.1)', E: 'rgba(241,149,29,0.1)', F: 'rgba(59,183,237,0.1)', G: 'rgba(102,98,255,0.1)', N: 'rgba(255,79,156,0.1)', other: 'rgba(91,156,249,0.1)' }
  let temp = val.treenumber ? val.treenumber.slice(0, 1) : ''
  if (!'ABCDEFGN'.includes(temp)) {
    temp = 'other'
  }
  return (
    <div key={val.name} className={styles.tag} style={{ color: colors[temp], backgroundColor: bgColors[temp] }}>{val.name}</div>
  )
}
